<div class="flex flex-col h-full flex-grow-0">
    <router-outlet></router-outlet>
</div>

